import React from "react"
import PropTypes from "prop-types"
import CaseBannerEnhanced from "../../components/CaseBanner/CaseBannerEnhanced"
import EmployeeCaseSummaryEnhanced from "../../components/EmployeeCaseSummary/EmployeeCaseSummaryEnhanced"
import EmployeeCaseUserVisitListEnhanced from "../../components/EmployeeCaseUserVisitList/EmployeeCaseUserVisitListEnhanced"
import PatientCaseSummaryEnhanced from "../../components/PatientCaseSummary/PatientCaseSummaryEnhanced"
import ExposedEmployeeListEnhanced from "../../components/ExposedEmployeeList/ExposedEmployeeListEnhanced"
import ExposedLocationListEnhanced from "../../components/ExposedLocationList/ExposedLocationListEnhanced"
import ExposedLocationVisitListModal from "../../components/ExposedLocationVisitListModal"
import ExposedAssetListEnhanced from "../../components/ExposedAssetList/ExposedAssetListEnhanced"
import ExposedAssetVisitListModal from "../../components/ExposedAssetVisitListModal"
import ExposedVisitListModal from "../../components/ExposedVisitListModal"
import Loading from "../../components/Loading"
import "./CaseDetail.scss"

const CaseDetail = (props) => (
  <div className="CaseDetail">
    {!props.type && <Loading />}
    {props.type && <CaseBannerEnhanced />}
    {props.type === "employeePositive" && (
      <EmployeeCaseSummaryEnhanced
        visitModal={EmployeeCaseUserVisitListEnhanced}
      />
    )}
    {props.type === "patientPositive" && <PatientCaseSummaryEnhanced />}
    {props.type && (
      <ExposedEmployeeListEnhanced
        type={props.type}
        caseStartAt={props.caseStartAt}
        caseEndAt={props.caseEndAt}
        onRowClickComponent={ExposedVisitListModal}
      />
    )}
    {props.type === "employeePositive" && (
      <ExposedLocationListEnhanced
        caseStartAt={props.caseStartAt}
        caseEndAt={props.caseEndAt}
        onRowClickComponent={ExposedLocationVisitListModal}
      />
    )}
    {props.type === "patientPositive" && (
      <ExposedAssetListEnhanced
        onRowClickComponent={ExposedAssetVisitListModal}
      />
    )}
  </div>
)

CaseDetail.propTypes = {
  caseStartAt: PropTypes.string,
  caseEndAt: PropTypes.string,
  type: PropTypes.oneOf(["patientPositive", "employeePositive"]),
}

export default CaseDetail
